import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Fallback poller for the document upload status page.
//
// The page is updated live via Turbo refresh broadcasts from the upload job,
// but Turbo debounces/coalesces those refresh broadcasts and the terminal
// (completed/failed) broadcast can be dropped if it lands during an in-flight
// refresh - leaving the page stuck on a processing step.
//
// While the upload is still processing, this controller asks Turbo to refresh
// the page on an interval so it reliably converges on the terminal state.
// Turbo.session.refresh() goes through the same morph-refresh path as the
// server broadcast and no-ops while a visit is already in flight, so it
// composes with the live broadcasts rather than fighting them. The poll stops
// as soon as the upload is no longer processing.
export default class extends Controller {
  static values = {
    processing: Boolean,
    interval: { type: Number, default: 4000 }
  }

  // Fires on connect and whenever the morph refresh updates the attribute, so
  // it both starts the poll and stops it once the upload reaches a terminal
  // state - without relying on the controller disconnecting.
  processingValueChanged(processing) {
    if (processing) {
      this.start()
    } else {
      this.stop()
    }
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (this.timer) return
    this.timer = setInterval(() => {
      Turbo.session.refresh(window.location.href)
    }, this.intervalValue)
  }

  stop() {
    if (!this.timer) return
    clearInterval(this.timer)
    this.timer = null
  }
}
